import React from "react";
import { faFile } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { Button, Modal, Input, Select } from "ui-kit-sahadevia";

import { addInvoice, updateInvoice } from "../../requests/invoice";

export default class ModalInvoice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      nameFile: "",
      price: "",
      date: "",
      type: "DEFAULT",
      base64: "",
      mime: "",
      types: [
        { text: "Facture entrante", value: "0" },
        { text: "Facture sortante", value: "1" },
      ],
    };
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleInputFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.setState({
          nameFile: file.name,
          mime: file.type,
          base64: reader.result,
        });
      };
      reader.onerror = () => {
        this.refFile.value = "";
        this.setState({
          mime: "",
          base64: "",
        });
        alert("Une erreur est survenue");
      };
    }
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.isUpdate &&
      this.props.show &&
      JSON.stringify(prevProps.data) !== JSON.stringify(this.props.data)
    ) {
      this.setState({
        name: this.props.data.name,
        price: this.props.data.price,
        date: moment(this.props.data.date, "DD/MM/YYYY").format("YYYY-MM-DD"),
        type: this.props.data.type,
      });
    }
  }

  addInvoice = () => {
    if (
      this.state.name &&
      this.state.price &&
      this.state.date &&
      this.state.type !== "DEFAULT" &&
      this.state.base64 &&
      this.state.mime
    ) {
      addInvoice(
        this.state.name,
        this.state.price,
        this.state.date,
        this.state.type,
        this.state.base64,
        this.state.mime,
        (result) => {
          if (result.success) {
            this.onClose(true);
          } else {
            alert("Une erreur est survenue");
          }
        }
      );
    } else {
      alert("Veuillez remplir tous les champs obligatoires");
    }
  };

  updateInvoice = () => {
    if (
      this.state.name &&
      this.state.price &&
      this.state.date &&
      this.state.type !== "DEFAULT"
    ) {
      updateInvoice(
        this.props.data.id,
        this.state.name,
        this.state.price,
        this.state.date,
        this.state.type,
        (result) => {
          if (result.success) {
            this.onClose(true);
          } else {
            alert("Une erreur est survenue");
          }
        }
      );
    } else {
      alert("Veuillez remplir tous les champs obligatoires");
    }
  };

  onClose = (isReload) => {
    this.setState(
      {
        name: "",
        nameFile: "",
        price: "",
        date: "",
        type: "DEFAULT",
        base64: "",
        mime: "",
      },
      () => {
        this.props.onClose(isReload);
      }
    );
  };

  render() {
    return (
      <>
        <Modal show={this.props.show} title={this.props.title}>
          <Input
            title="Nom"
            type="text"
            placeholder="Nom"
            name="name"
            value={this.state.name}
            onChange={this.handleInputChange}
          />
          <Input
            title="Montant (en €)"
            type="text"
            placeholder="Montant"
            name="price"
            value={this.state.price}
            onChange={this.handleInputChange}
          />
          <Input
            title="Date"
            type="date"
            placeholder="Date"
            name="date"
            value={this.state.date}
            onChange={this.handleInputChange}
          />
          <Select
            title="Type"
            name="type"
            value={this.state.type}
            onChange={this.handleInputChange}
            defaultValue={"Veuillez sélectionner un type"}
            options={this.state.types}
          />
          {!this.props.isUpdate ? (
            <div style={{ display: "flex", marginBottom: "1rem" }}>
              <Button
                icon={faFile}
                text="Sélectionner un fichier"
                onClick={() => this.refFile.click()}
              />
              <span
                style={{
                  display: "inline-block",
                  margin: "auto",
                  marginLeft: "1rem",
                  fontSize: "12px",
                }}
              >
                {this.state.nameFile}
              </span>
            </div>
          ) : null}

          <div style={{ display: "flex" }}>
            <Button
              style={{ marginLeft: "auto" }}
              text="Annuler"
              onClick={() => this.onClose(false)}
            />
            <Button
              text={this.props.isUpdate ? "Modifier" : "Ajouter"}
              onClick={
                this.props.isUpdate ? this.updateInvoice : this.addInvoice
              }
            />
          </div>
        </Modal>
        <input
          style={{ display: "none" }}
          ref={(ref) => (this.refFile = ref)}
          type="file"
          name="file"
          onChange={this.handleInputFileChange}
        />
      </>
    );
  }
}
